import { RrRepository } from "../../repositories/rr_repository";
import { CarouselItem } from "../item";
import { RrAreaProfile } from "../rr_profile";
import {SiteType} from "../js_env";

const INCLUDES_VARIATION = true;

interface RrCatalogItem {
    catalogItemCode: string;
    variationCode: string;
    rrLinkUrl: string;
}

export const getRrTitleAndCatalogItems = (placementName: string, displayCount?: number) => {
    const hasPlacements = 'placements' in window['RR'].data.JSON;

    if (!hasPlacements) {
        return { rrTitle: "", rrCatalogItems: new Array() }
    }

    const rrResponse: any = window['RR'].data.JSON;

    // placementNameでどのRRエリアのデータなのかを区別する。
    // RRから戻り値のplacementNameは「category_page.recomRR_m_01」「item_page.recomRR_Item_01」などのような形
    const placement: any = rrResponse.placements.find((placement: any) => placement.placement_name.split(".")[1] === placementName);

    if (typeof placement === 'undefined') return { rrTitle: "", rrCatalogItems: new Array() }

    const rrCatalogItems = placement.items.map((item: any) => {
        const rrCatalogItem: RrCatalogItem = {
            catalogItemCode: item.id,
            variationCode: zeroSuppress(item.product_short_name),
            rrLinkUrl: item.link_url
        };
        return rrCatalogItem;
    });
    const itemCount = (displayCount && displayCount < rrCatalogItems.length) ? displayCount : rrCatalogItems.length;

    const rrCatalogItem = rrCatalogItems.slice(0, itemCount);

    return { rrTitle: placement.strategy_message, rrCatalogItems: rrCatalogItem }

}

export const getRrAreaData = async (profile: RrAreaProfile): Promise<{ items: CarouselItem[], title: string }> => {
    const rrTitleAndCatalogItems = getRrTitleAndCatalogItems(profile.placementName, profile.displayCount);
    const rrRepository = new RrRepository();
    if (rrTitleAndCatalogItems.rrCatalogItems.length <= 0) {
        return { items: Array(), title: rrTitleAndCatalogItems.rrTitle }
    }

    const carouselItems = await rrRepository.getRrItemsDetail(rrTitleAndCatalogItems.rrCatalogItems.map((item: any) => item.catalogItemCode), INCLUDES_VARIATION, SiteType.CLUB);
    
    // RRから返却されたリンクを各CarouselItemに設定する
    const carouselItemsWithRrLinkUrl = carouselItems.map(carouselItem => {
        const targetItem = rrTitleAndCatalogItems.rrCatalogItems.find(rrCatalogItem => carouselItem.itemCode === rrCatalogItem.catalogItemCode || carouselItem.itemCode === rrCatalogItem.variationCode);
        if (targetItem !== undefined) {
            carouselItem.rrLinkUrl = targetItem.rrLinkUrl;
        }
        return carouselItem;
    })

    return {
        items: carouselItemsWithRrLinkUrl,
        title: rrTitleAndCatalogItems.rrTitle
    };
}

// 先頭ゼロ埋めされたバリエーションコードがRRから返却されるため、この処理を行う。
const zeroSuppress = str => {
    let idx = 0;
    while (str.charAt(idx) === '0') idx ++;
    return str.slice(idx);
}